// extracted by mini-css-extract-plugin
export default {"tooltip":"CustomTooltipInfo_tooltip__kimrK"};